import React from 'react';
import { Link } from 'react-router-dom';
import { ActivityInterface } from 'pages/Activities/activities.context';
import Edit from '@mui/icons-material/Edit';
import CustomIcon from 'components/Icon/CustomIcon';
import { useAuthContext } from 'context/auth.context';
import { hasPermissions } from 'config/ability';

const UpdateActivity = ({ activity, text }: { activity: ActivityInterface; text?: string }) => {
  const { ability } = useAuthContext();

  // Return null if user does not have 'Update' permissions
  if (!hasPermissions(ability, 'update', 'Activity')) {
    return null;
  }

  return (
    <Link style={{ width: '100%' }} to={`/activities/edit/${activity.id}`}>
      <CustomIcon label={text} icon={<Edit />} />
    </Link>
  );
};

export default UpdateActivity;
